// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestionsAndAnswers_wrapper__TQQhi","title":"QuestionsAndAnswers_title__Xbe62","item":"QuestionsAndAnswers_item__wNIkt","fadeInUp":"QuestionsAndAnswers_fadeInUp__KPC4s"};